import { Tracking } from "Types/api/Tracking";
import { ActionType } from "src/store/dataService/actions/utils/actionCreator";
import {
    patchTrackingFailure,
    patchTrackingRequest,
    patchTrackingSuccess,
    setTracking,
} from "src/store/actions/tracking";
import { getDealSuccess } from "src/store/actions/deal";
import { pollingSuccess } from "src/store/actions/poller";

export type TrackingState = Tracking;

function reducer(
    state: TrackingState = {},
    action:
        | ReturnType<typeof getDealSuccess>
        | ReturnType<typeof pollingSuccess>
        | ActionType<typeof patchTrackingRequest>
        | ActionType<typeof patchTrackingSuccess>
        | ActionType<typeof patchTrackingFailure>
        | ActionType<typeof setTracking>
): TrackingState {
    switch (action.type) {
        case getDealSuccess.type:
        case pollingSuccess.type:
            if (action.payload.deal?.tracking?.ccdp) {
                return {
                    ...state,
                    ccdp: {
                        ...state.ccdp,
                        ...action.payload.deal.tracking.ccdp,
                        ...(action.payload.deal.tracking.ccdp.visitor_ids &&
                            action.payload.deal.tracking.ccdp.visitor_ids.length && {
                                visitor_ids: [
                                    ...new Set([
                                        ...(state.ccdp?.visitor_ids || []),
                                        ...(action.payload.deal.tracking.ccdp?.visitor_ids || []),
                                    ]),
                                ],
                            }),
                    },
                };
            }

            return state;

        case setTracking.type:
        case patchTrackingRequest.type: {
            // merge ccdp visitor ids between state and incoming payload
            let ccdp = undefined;
            if (action.payload.tracking.ccdp || state.ccdp) {
                ccdp = {
                    ccdp: {
                        ...state.ccdp,
                        ...action.payload.tracking.ccdp,
                        visitor_ids: [
                            ...new Set([
                                ...(state.ccdp?.visitor_ids || []),
                                ...(action.payload.tracking.ccdp?.visitor_ids || []),
                            ]),
                        ],
                    },
                };
            }

            return { ...state, ...action.payload.tracking, ...ccdp };
        }

        case patchTrackingSuccess.type:
            return state;

        case patchTrackingFailure.type:
            return state;

        default:
            return state;
    }
}

export default reducer;
